export default "__VITE_ASSET__DIaN2RNH__"